"use client";

import config from "@/app.config";
import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import Link from "next/link";

export default function WhatsappButton() {
  const matches = useMediaQuery("(min-width:1024px)");

  if (!matches) {
    return null;
  }

  return (
    <Link
      href={`https://wa.me/+91${config.contact.whatsappNumber}`}
      target="_blank"
      className="block fixed bottom-8 right-6 z-10 space-y-2"
    >
      <Image
        src="/images/WhatsApp.svg"
        alt="WhatsApp"
        width={150}
        height={150}
        className="w-16 mx-auto"
      />
      <div className="text-white bg-black/50 px-2 py-0.5 rounded-2xl font-semibold animate-bounce uppercase">
        Contact Us
      </div>
    </Link>
  );
}
